export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const STATE_INIT = 'STATE_INIT';
export const SEARCH_PARAM = 'SEARCH_PARAM';
export const SEARCH_POPUP_PARAMS = 'SEARCH_POPUP_PARAMS';
export const PAGING_INFO = 'PAGING_INFO';
export const SET_FORM = 'SET_FORM';
export const POPUP_INIT = 'POPUP_INIT';
export const BAD_TYPE_POPUP_INIT = 'BAD_TYPE_POPUP_INIT';
export const HISTORY_PAGING_INFO = 'HISTORY_PAGING_INFO';
export const HISTORY_POPUP_INIT = 'HISTORY_POPUP_INIT';
export const SEARCH_POPUP_PARAM = 'SEARCH_POPUP_PARAM';
export const PPR_NO_PAGING_INFO = 'PPR_NO_PAGING_INFO';
export const PPR_NO_SEARCH_POPUP = 'PPR_NO_SEARCH_POPUP';

export default {
	STATE_INIT,
	DEFAULT_ASSIGN,
	SEARCH_PARAM,
	SEARCH_POPUP_PARAMS,
	PAGING_INFO,
	SET_FORM,
	POPUP_INIT,
	BAD_TYPE_POPUP_INIT,
	HISTORY_PAGING_INFO,
	HISTORY_POPUP_INIT,
	SEARCH_POPUP_PARAM,
	PPR_NO_PAGING_INFO,
	PPR_NO_SEARCH_POPUP
};
